<template>
  <div class="fill-height">
    <template v-if="authenticated">
      <v-main>
        <router-view v-if="configLoaded"></router-view>

        <!-- globální dialogy -->
        <CompanySelectionDialog ref="companySelectionDialog" v-on:selected="companySelected" />
        <GroupsetSelectionDialog ref="groupsetSelectionDialog" />
        <VehicleSelectionDialog ref="vehicleSelectionDialog" v-on:selected="vehicleSelected" />
        <FindVehicleDialog ref="findVehicleDialog" v-on:selected="vehicleFound" />
        <RefuelingDialog ref="refuelingDialog" />
        <VehicleLogDialog ref="vehicleLogDialog" />
        <RideUpdateDialog ref="rideUpdateDialog" />
        <VehicleUpdateDialog ref="vehicleUpdateDialog" />
      </v-main>
    </template>
    <login-form v-else-if="!waitToToken" @login="login" />
    <loading />
  </div>
</template>

<script>
import Vue from "vue";
import loginForm from "@/components/LoginForm";
import loading from "@/components/Loading";
import CompanySelectionDialog from "@/components/dialogs/CompanySelectionDialog";
import GroupsetSelectionDialog from "@/components/dialogs/GroupsetSelectionDialog";
import VehicleSelectionDialog  from "@/components/dialogs/VehicleSelectionDialog";
import FindVehicleDialog from "@/components/dialogs/FindVehicleDialog";
import RefuelingDialog from "@/components/dialogs/RefuelingDialog";
import VehicleLogDialog from "@/components/dialogs/VehicleLogDialog";
import RideUpdateDialog from "@/components/dialogs/RideUpdateDialog.vue";
import VehicleUpdateDialog from "@/components/dialogs/VehicleUpdateDialog.vue";

export default {
  name: "Main",

  components: {
    loginForm,
    loading,
    CompanySelectionDialog,
    GroupsetSelectionDialog,
    VehicleSelectionDialog,
    FindVehicleDialog,
    RefuelingDialog,
    VehicleLogDialog,
    RideUpdateDialog,
    VehicleUpdateDialog
  },

  data() {
    return {
      servicesRunning: false,
      waitToToken: false
    };
  },

  created() {
    window.addEventListener("beforeunload", this.beforeWindowUnload);
    // autorizacni store spustime hned, protoze pokud je uzivatel prihlaseny (data v localStorage), muze to rovnou zacit fungovat
    this.$store.dispatch("auth/start");
    if (this.user) {
      setTimeout(() => {
        // tento prikaz udela to, ze zustane po refreshi stranky viset nacitani stranky do stisknuti ESC. Kdyz se to vola
        // az po urcite dobe, tak to nejakou zahadou funguje a nacitani stranky skonci normalne...
        // Zatim se mi nepodarilo zjistit, na cem to je zavisle, treba nekdy...
        this.startServices();
      }, 500);
    }
  },

  methods: {
    login(authData, doneCallback) {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch("auth/login", authData).then((response) => {
        // sluzby se startuji ve watcheru na usera. Teoreticky je mozne volat login z login formu primo, uz to neni potreba dostat sem
        doneCallback(true);
      }).catch((error) => {
        console.log("login error: ", error);
        doneCallback(false);
      });
    },

    startServices() {
      if (!this.servicesRunning) {
        this.servicesRunning = true;
        // spusteni stahovani seznamu zarizeni
        this.$store.dispatch("online/start");
        // nacteni obecne konfigurace (neco jako enum, vicemene staticke veci)
        //this.$store.dispatch('config/loadConfig')
      }
    },

    stopServices() {
      if (this.servicesRunning) {
        this.servicesRunning = false;
        // zastaveni stahovani seznamu zarizeni
        this.$store.dispatch("online/stop");
      }
    },

    // eslint-disable-next-line no-unused-vars
    beforeWindowUnload(event) {
      // uzivatel opousti stranku nebo dela refresh. Zastavime sluzby. Event store vyhazuje chybu spojeni, kdyz se neukonci korektne,
      // a i kdyz to nejak zasadne nicemu nevadi, cim mene chyb v konzoli, tim lip.
      this.stopServices();
    },

    companySelected(company) {
      this.$router.push({ name: this.$route.name, params: { ccode: company.code } });
    },

    vehicleSelected(vehicle) {
      if (this.$store.state.history.vehicle !== null)
        this.$store.dispatch("history/fetch", {
          vehicleId: vehicle.vehicleId,
          periodFrom: this.$store.state.history.periodFrom,
          periodTo: this.$store.state.history.periodTo
        });
      else if (this.$store.state.logbook.vehicle !== null)
        this.$store.dispatch("logbook/fetch", {
          vehicle: vehicle,
          periodFrom: this.$store.state.logbook.periodFrom,
          periodTo: this.$store.state.logbook.periodTo
        });
      else if (this.$store.state.refueling.vehicle !== null)
        this.$store.dispatch("refueling/fetch", {
          vehicle: vehicle,
          periodFrom: this.$store.state.refueling.periodFrom,
          periodTo: this.$store.state.refueling.periodTo
        });
      else if (this.$store.state.events.vehicle !== null)
        this.$store.dispatch("events/fetch", {
          vehicle: vehicle,
          periodFrom: this.$store.state.events.periodFrom,
          periodTo: this.$store.state.events.periodTo
        });
      else if (this.$store.state.service.vehicle !== null)
        this.$store.dispatch("service/fetch", {
          vehicle: vehicle
        });
      else if (this.$store.state.contracts.vehicle !== null)
        this.$store.dispatch("contracts/fetch", {
          vehicle: vehicle,
          periodFrom: this.$store.state.contracts.periodFrom,
          periodTo: this.$store.state.contracts.periodTo
        });
      else
        this.$router.push({ name: "map/vehicle", params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId } });
    },

    vehicleFound(vehicle) {
      this.$router.push({ name: "map/vehicle", params: { ccode: vehicle.companyCode, id: vehicle.vehicleId } });
    },

    globaKeyPress(keyEvent) {
      if (this.authenticated) {
        if (keyEvent.key === "F9")
          this.$router.push({ name: "map" });
        else if (keyEvent.key === "F2")
          this.$store.dispatch("dialogs/showDialog", {
            dialog: "companySelection", options: true
          });
        else if (keyEvent.key === "F4")
          this.$store.dispatch("dialogs/showDialog", {
            dialog: "groupsetSelection", options: true
          });
        else if (keyEvent.ctrlKey && keyEvent.key === "F8")
          this.$store.dispatch("dialogs/showDialog", {
            dialog: "findVehicle", options: true
          });
        else if (keyEvent.key === "F8")
          this.$store.dispatch("dialogs/showDialog", {
            dialog: "vehicleSelection", options: true
          });
        else if (keyEvent.altKey && keyEvent.key === "r")
          this.$store.dispatch("dialogs/showDialog", {
            dialog: "importRefueling", options: true
          });
        else if (keyEvent.altKey && keyEvent.key === "g")
          this.$router.push({ name: "map-preview" });
      }
    }
  },

  computed: {
    user() {
      return this.$store.state.auth.token;
    },

    authenticated() {
      return this.user !== null;
    },

    configLoaded() {
      return this.$store.state.online.fetched;
    }
  },

  watch: {
    user(newVal, oldVal) {
      if (newVal && !oldVal) {
        // uzivatel se prihlasil - spustit sluzby. Nespousti se v pripade, ze se jedna o refresh tokenu (zajisteno i jinak, ale pro poradek)
        this.startServices();
      }

      if (!newVal) {
        // pokud nastane chyba behem provozu a uzivatele to "odhlasi", tak zastavit sluzby taky, ale nevolat logout, protoze to smaze i chybu
        this.stopServices();

        this.waitToToken = false;
        this.$forceUpdate();
      }
    },

    // dialogs
    "$store.state.dialogs.companySelection": function(value) {
      if (value !== null)
        this.$refs.companySelectionDialog.open();
    },

    "$store.state.dialogs.groupsetSelection": function(value) {
      if (value !== null)
        this.$refs.groupsetSelectionDialog.open();
    },

    "$store.state.dialogs.vehicleSelection": function(value) {
      if (value !== null)
        this.$refs.vehicleSelectionDialog.open();
    },

    "$store.state.dialogs.findVehicle": function(value) {
      if (value !== null)
        this.$refs.findVehicleDialog.open();
    },

    "$store.state.dialogs.refueling": function(value) {
      if (value !== null)
        this.$refs.refuelingDialog.open(value.refueling);
    },

    "$store.state.dialogs.vehicleLog": function(value) {
      if (value !== null)
        this.$refs.vehicleLogDialog.open(this.$store.state.dialogs.vehicleLog.vehicle);
    },

    "$store.state.dialogs.rideUpdate": function(value) {
      if (value !== null)
        this.$refs.rideUpdateDialog.open(value);
    },

    "$store.state.dialogs.vehicleUpdate": function(value) {
      if (value !== null)
        this.$refs.vehicleUpdateDialog.open(value);
    }
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  },

  mounted() {
    window.addEventListener("keydown", e => this.globaKeyPress(e));

    if (Vue.$cookies.isKey("token")) {
      this.waitToToken = true;
      this.$store.dispatch("auth/tokenRequest", Vue.$cookies.get("token"))
        .catch(() => {
          this.waitToToken = false;
        });
    }
  }
};
</script>
